import HttpService from "./HttpService";
const API_ENDPOINT = "/employees";

const EmployeeDocumentService = {
  async createEmployee(formData) {
    try {
      const response = await HttpService.post(API_ENDPOINT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any other headers if required
        },
      });
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateEmployee(employeeId, data) {
    console.log(typeof data);

    data["_method"] = "PUT";
    try {
      const response = await HttpService.post(
        `${API_ENDPOINT}/${employeeId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getEmployees(parameters, pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);

    try {
      const response = await HttpService.post(
        "/employees-list?" + pageConfigParams,
        parameters,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
  },
  async getTeamEmployees(parameters, pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);

    try {
      const response = await HttpService.post(
        "/team-list/employee-list-team-search?" + pageConfigParams,
        parameters,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
  },
  async getTeamEmployeesWithoutPagination() {
    try {
      const response = await HttpService.post(
        "/team-list/employee-list-team-search-without-pagination",
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
  },
  async getUsers() {
    try {
      const response = await HttpService.get("/user-list");
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  },
  async getReportingAuthorities() {
    try {
      const response = await HttpService.get("/all-employee-reporting");
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  },
  async fetchEmployeeShift(id) {
    try {
      const response = await HttpService.get(
        `/attendance-employee-shift/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  },

  async fetchEmployeeHcmId(data) {
    try {
      const response = await HttpService.post("/employee-hcm-id", data);
      return response.data;
    } catch (error) {
      console.error("Error fetching employee hcm id:", error);
      throw error;
    }
  },
  async fetchDivisionWiseEmployee(data) {
    try {
      const response = await HttpService.post("/division-employee", data);
      return response.data;
    } catch (error) {
      console.error("Error fetching division wise employee:", error);
      throw error;
    }
  },
  async fetchEmployeeDesignation(data) {
    try {
      const response = await HttpService.post("/employee-designation", data);
      return response.data;
    } catch (error) {
      console.error("Error fetching employee hcm id:", error);
      throw error;
    }
  },
  async getEmployeesSalary() {
    try {
      const response = await HttpService.post("/employees-salary-benefit");
      return response.data;
    } catch (error) {
      console.error("Error fetching employees salary/benefits:", error);
      throw error;
    }
  },
  async getEmployeeSalaryPaginated(pageConfig, parameters) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.post(
        `/employees-salary-benefit-paginated?${pageConfigParams}`,
        parameters,
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getEmployeeSalaryWithFilters(pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `/payroll/salary-benefit/employees?${pageConfigParams}`,
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getEmployeeDetails(employeeId) {
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}/${employeeId}/edit`,
      );
      return response.data;
    } catch (error) {
      console.error("Error getting employee details:", error);
      throw error;
    }
  },
  async getEmployeeView(employeeId) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${employeeId}`);
      return response.data;
    } catch (error) {
      console.error("Error viewing employee details:", error);
      throw error;
    }
  },
  async getEmployeeLogs(employeeId, pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `/employees/${employeeId}/logs?${pageConfigParams}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error viewing employee details:", error);
      throw error;
    }
  },
  // Employees with ID and name value for dropdowns
  async getAllEmployees(parameters) {
    try {
      const response = await HttpService.get("/employees-list");
      return response.data;
    } catch (error) {
      console.error("Error fetching all employees:", error);
      throw error;
    }
  },
  async getEmployeesWithoutSalary() {
    try {
      const response = await HttpService.get("/employees/without-salary");
      return response.data;
    } catch (error) {
      console.error("Error fetching all employees:", error);
      throw error;
    }
  },
  async getEmployeesWithoutAccountDetails() {
    try {
      const response = await HttpService.get(
        "/employees/without-account-detail",
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching all employees:", error);
      throw error;
    }
  },
  async getEmployeesWithoutBenefitInformation() {
    try {
      const response = await HttpService.get(
        "/employees/without-benefit-information",
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching all employees:", error);
      throw error;
    }
  },
  async getAllRecruiters() {
    try {
      const response = await HttpService.get("/recruiter-list-view");
      return response.data;
    } catch (error) {
      console.error("Error fetching all recruiter:", error);
      throw error;
    }
  },
  // Get employees department wise
  async getDepartmentEmployees(departmentId) {
    try {
      const response = await HttpService.get(`employee-get/${departmentId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching from (`employee-get/${departmentId}`):",
        error,
      );
      throw error;
    }
  },

  async getDivisionDepartmentEmployees(divisionId, departmentId) {
    try {
      const response = await HttpService.get(
        `/employees-list-department/${divisionId}/${departmentId}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching from (`employee-deparment-designation-wise/${departmentId}`):",
        error,
      );
      throw error;
    }
  },

  // Get employees department and designation wise
  async getDepartmentDesignationEmployees(departmentId, designationId) {
    try {
      const response = await HttpService.get(
        `/employee-deparment-designation-wise/${departmentId}/${designationId}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching from (`employee-deparment-designation-wise/${departmentId}`):",
        error,
      );
      throw error;
    }
  },

  async getDesignationEmployees(designationId) {
    try {
      const response = await HttpService.get(
        `employee-list-designation/${designationId}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching from (`employee-get/${designationId}`):",
        error,
      );
      throw error;
    }
  },
  async getDirectReportingEmployees(reportingAuthorityId) {
    try {
      const response = await HttpService.get(
        `direct-reporting-employees/${reportingAuthorityId}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching from (`direct-reporting-employees/${reportingAuthorityId}`):",
        error,
      );
      throw error;
    }
  },
  async deleteEmployee(employeeId) {
    try {
      const response = await HttpService.delete(
        `${API_ENDPOINT}/${employeeId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default EmployeeDocumentService;
